import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ReportViewsState } from "./report-view.model";
import * as ReportViewActions from "./report-view.actions";
import { map } from "rxjs";

@Injectable()
export class ReportViewEffects {
    constructor(
        private store$: Store<ReportViewsState>,
        private actions$: Actions
    ) { }
    intitializeReportView = createEffect(() => this.actions$.pipe(
        ofType(ReportViewActions.initializeReportView),
        map(action => {
            console.log('initializeReportView', action);
            const newAction = ReportViewActions.initializeReportViewSuccess({
                reportName: action.config.reportName,
                reportViewState: {
                    config: action.config,
                    reportName: action.config.reportName,
                    perspectives: action.config.perspectives,
                    selectedPerspective: action.config.perspectives[0],
                    filters: [],
                    filterSelections: []
                }
            });

            return newAction;
        })
    ));
}